import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useState } from "react";
import { pickPersInf, hasPersInfs, noPersInfs } from "../../lib/misc-helpers";
import VerbInfoItemDisplay from "./VerbInfoItemDisplay";
import PersonInfsPicker from "../PersInfsPicker";
import VerbTypeInfo from "./VerbTypeInfo";
import Hider from "../Hider";
import fadedTree from "./faded-tree.svg"; // import camera from "../icons/camera-fill";
// import video from "../icons/camera-video-fill";

var indentR = {
  paddingLeft: "1rem"
};
var title = {
  fontWeight: "bolder",
  marginBottom: "0.5rem",
  marginTop: "0.5rem"
};
export function RootsAndStems(_ref) {
  var textOptions = _ref.textOptions,
      info = _ref.info;
  var hasPerfectiveSplit = !!(info.root.perfectiveSplit || info.stem.perfectiveSplit);
  var showPersInf = hasPersInfs(info);

  var _useState = useState("mascSing"),
      _useState2 = _slicedToArray(_useState, 2),
      persInf = _useState2[0],
      setPersInf = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      split = _useState4[0],
      setSplit = _useState4[1];

  var perfectiveStem = info.stem.perfectiveSplit && split ? info.stem.perfectiveSplit : info.stem.perfective;
  var perfectiveRoot = info.root.perfectiveSplit && split ? info.root.perfectiveSplit : info.root.perfective;
  var colClass = "col col-md-5 px-0 mb-1";
  var rowClass = "row justify-content-between";
  return _jsxs("div", Object.assign({
    className: "mt-3"
  }, {
    children: [showPersInf && _jsx(PersonInfsPicker, {
      persInf: persInf,
      handleChange: function handleChange(p) {
        return setPersInf(p);
      },
      transitivity: info.transitivity
    }, void 0), _jsx("div", Object.assign({
      className: "verb-info",
      style: {
        textAlign: "center",
        maxWidth: "500px",
        margin: "0 auto",
        backgroundImage: "url(".concat(fadedTree, ")"),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 35%",
        backgroundSize: "50%"
      }
    }, {
      children: _jsxs("div", Object.assign({
        style: {
          border: "2px solid black",
          padding: "1rem",
          margin: "0.25rem"
        },
        className: "container"
      }, {
        children: [_jsxs("div", Object.assign({
          className: rowClass + " align-items-center"
        }, {
          children: [_jsx("div", Object.assign({
            className: colClass
          }, {
            children: _jsx("i", {
              className: "fas fa-video fa-lg"
            }, void 0)
          }), void 0), _jsx("div", Object.assign({
            className: colClass
          }, {
            children: _jsxs("div", Object.assign({
              className: "d-flex flex-row justify-content-center align-items-center"
            }, {
              children: [_jsx("div", {
                children: _jsx("i", {
                  className: "fas fa-camera fa-lg mx-3"
                }, void 0)
              }, void 0), hasPerfectiveSplit && _jsx("div", {
                children: _jsx("button", Object.assign({
                  className: "btn btn-sm btn-outline-secondary",
                  onClick: function onClick() {
                    return setSplit(!split);
                  }
                }, {
                  children: "split"
                }), void 0)
              }, void 0)]
            }), void 0)
          }), void 0)]
        }), void 0), _jsxs("div", Object.assign({
          className: rowClass
        }, {
          children: [_jsxs("div", Object.assign({
            className: colClass
          }, {
            children: [_jsx("div", Object.assign({
              style: title
            }, {
              children: _jsx("div", {
                children: "Imperfective Stem"
              }, void 0)
            }), void 0), _jsx("div", Object.assign({
              style: indentR
            }, {
              children: _jsx(VerbInfoItemDisplay, {
                item: pickPersInf(info.stem.imperfective, persInf),
                textOptions: textOptions,
                tails: true
              }, void 0)
            }), void 0)]
          }), void 0), _jsxs("div", Object.assign({
            className: colClass
          }, {
            children: [_jsx("div", Object.assign({
              style: title
            }, {
              children: _jsx("div", {
                children: "Perfective Stem"
              }, void 0)
            }), void 0), _jsx("div", Object.assign({
              style: indentR
            }, {
              children: _jsx(VerbInfoItemDisplay, {
                item: pickPersInf(perfectiveStem, persInf),
                textOptions: textOptions,
                tails: true
              }, void 0)
            }), void 0)]
          }), void 0)]
        }), void 0), _jsxs("div", Object.assign({
          className: rowClass
        }, {
          children: [_jsxs("div", Object.assign({
            className: colClass
          }, {
            children: [_jsx("div", Object.assign({
              style: title
            }, {
              children: _jsx("div", {
                children: "Imperfective Root"
              }, void 0)
            }), void 0), _jsx("div", Object.assign({
              style: indentR
            }, {
              children: _jsx(VerbInfoItemDisplay, {
                item: pickPersInf(info.root.imperfective, persInf),
                textOptions: textOptions
              }, void 0)
            }), void 0)]
          }), void 0), _jsx("div", Object.assign({
            className: colClass
          }, {
            children: _jsxs("div", {
              children: [_jsx("div", Object.assign({
                style: title
              }, {
                children: _jsx("div", {
                  children: "Perfective Root"
                }, void 0)
              }), void 0), _jsx("div", Object.assign({
                style: indentR
              }, {
                children: _jsx(VerbInfoItemDisplay, {
                  item: pickPersInf(perfectiveRoot, persInf),
                  textOptions: textOptions
                }, void 0)
              }), void 0)]
            }, void 0)
          }), void 0)]
        }), void 0), _jsxs("div", Object.assign({
          className: "text-center"
        }, {
          children: [_jsx("div", Object.assign({
            style: title
          }, {
            children: "Past Participle"
          }), void 0), _jsx(VerbInfoItemDisplay, {
            item: pickPersInf(info.participle.past, persInf),
            textOptions: textOptions
          }, void 0)]
        }), void 0)]
      }), void 0)
    }), void 0)]
  }), void 0);
}

function VerbInfo(_ref2) {
  var info = _ref2.info,
      textOptions = _ref2.textOptions,
      showingStemsAndRoots = _ref2.showingStemsAndRoots,
      toggleShowingSar = _ref2.toggleShowingSar;
  var inf = noPersInfs(info.root.imperfective).long;
  return _jsxs("div", Object.assign({
    className: "my-3"
  }, {
    children: [_jsx(VerbTypeInfo, {
      info: info,
      textOptions: textOptions
    }, void 0), _jsx(Hider, Object.assign({
      showing: showingStemsAndRoots,
      label: "\uD83C\uDF33 Roots and Stems for ".concat(inf.p),
      handleChange: toggleShowingSar,
      hLevel: 4
    }, {
      children: _jsx(RootsAndStems, {
        textOptions: textOptions,
        info: info
      }, void 0)
    }), void 0)]
  }), void 0);
}

export default VerbInfo;